import { Link } from "react-router-dom";

import { desde } from "../api.ts";
import { Barras, Cartao, Vazio } from "../componentes/basicos.tsx";
import { useDados } from "../usarDados.ts";

type Eixo = {
  titulo: string; pergunta: string;
  fatias: { rotulo: string; total: number }[];
  enfase?: string; critico?: string; ordenado?: boolean;
};
type Visao = {
  totalAtivas: number;
  semTelemetria: number;
  tiles: { valor: string; rotulo: string; sub: string }[];
  eixos: Eixo[];
  perfil: { rotulo: string; valor: string }[];
  tabela: {
    maquina_id: number; empresa: string; hostname: string; versao: string;
    so: string; arquitetura: string; cpu: string; ram: string;
    disco_livre: string; ultimo_erro: string; ultima_batida: string | null;
  }[];
};

/**
 * O trabalho desta tela, declarado antes de tudo: "o que esta instalado na
 * frota AGORA, e o que disso e problema."
 *
 * Nao historico (isso e a tela da maquina) e nao silencio (isso e o painel).
 * Manter essa fronteira e o que impede a pagina virar um segundo dashboard.
 */
export function Telemetria() {
  const { dados: v, erro, carregando } = useDados<Visao>("/telemetria");

  if (carregando) return <div className="carregando">carregando...</div>;
  if (erro || !v) return <div className="alerta alerta--erro">{erro}</div>;

  return (
    <>
      <h1>Telemetria da frota</h1>
      <p className="suave pequeno" style={{ marginTop: "calc(-1 * var(--e-md))" }}>
        Retrato de {v.totalAtivas} maquina(s) ativa(s)
        {v.semTelemetria > 0 && ` · ${v.semTelemetria} ainda sem telemetria nenhuma`}
      </p>

      <div className="tiles">
        {v.tiles.map((t) => (
          <div key={t.rotulo} className="tile">
            <div className="tile__valor" style={{ fontSize: "var(--t-h1)" }}>{t.valor}</div>
            <div className="tile__rotulo">{t.rotulo}</div>
            <div className="tile__sub">{t.sub}</div>
          </div>
        ))}
      </div>

      <div className="grade grade--2">
        {v.eixos.map((e) => (
          <Cartao key={e.titulo} titulo={e.titulo} pergunta={e.pergunta}>
            {e.fatias.length === 0 ? <Vazio titulo="Sem dados" /> : (
              <Barras fatias={e.fatias} enfase={e.enfase} critico={e.critico} />
            )}
            {e.enfase && (
              <p className="micro apagado mt-lg mb-0">
                Em destaque: {e.enfase}, a versao mais nova. As demais estao atrasadas.
              </p>
            )}
          </Cartao>
        ))}
      </div>

      {/* Arquitetura, produto e dominio tem 2-3 classes cada. Tres graficos
          magros de duas barras seriam tres graficos que nao dizem nada. */}
      <Cartao titulo="Perfil da frota">
        <dl className="perfil">
          {v.perfil.map((p) => (
            <div key={p.rotulo} style={{ display: "contents" }}>
              <dt>{p.rotulo}</dt><dd>{p.valor}</dd>
            </div>
          ))}
        </dl>
      </Cartao>

      <Cartao titulo="Frota telemetrada"
              pergunta="a valvula de escape: mais de sete classes viram tabela, nao mais cores">
        <div className="tabela-rolagem">
          <table className="tabela">
            <thead>
              <tr>
                <th>Empresa</th><th>Maquina</th><th>Versao</th><th>SO</th>
                <th>Arq.</th><th>CPU</th><th>RAM</th><th>Disco livre</th>
                <th>Ultimo erro</th><th>Ultima batida</th>
              </tr>
            </thead>
            <tbody>
              {v.tabela.map((m) => (
                <tr key={m.maquina_id}>
                  <td className="suave pequeno">{m.empresa}</td>
                  <td><Link to={`/maquinas/${m.maquina_id}`}>{m.hostname}</Link></td>
                  <td className="pequeno">{m.versao || "--"}</td>
                  <td className="suave pequeno">{m.so || "--"}</td>
                  <td className="suave pequeno">{m.arquitetura || "--"}</td>
                  <td className="suave pequeno">{m.cpu}</td>
                  <td className="tabela__num">{m.ram}</td>
                  <td className="tabela__num">{m.disco_livre}</td>
                  <td className="tabela__erro" title={m.ultimo_erro}>{m.ultimo_erro}</td>
                  <td className="suave pequeno">{desde(m.ultima_batida)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Cartao>
    </>
  );
}
